import React from 'react';
import PropTypes from 'prop-types';
import { useReporter } from '../../reporter';
import { ResponsiveImage } from '../ResponsiveImage';
import { CtaButton } from '../CtaButton';
import { orientationSettings } from './constants';
import { heroButtonClicked } from './events';
import {
  StyledHero,
  BackgroundImage,
  ContentContainer,
  Content,
  Header,
  Subheader,
  ButtonWrapper,
} from './styles.js';

export const Hero = ({
  headline,
  subheadline,
  link,
  image,
  backgroundColor = 'background.base',
  fontColor = 'text.primary',
  horizontalOrientation = 'left',
  buttonVariant,
}) => {
  const reporter = useReporter();

  return (
    <StyledHero backgroundColor={backgroundColor}>
      {/* $ is to prevent `srcSet` from being forward to the DOM */}
      <BackgroundImage>
        <ResponsiveImage {...image} objectFit="cover" />
      </BackgroundImage>
      <ContentContainer
        $srcSet={image.srcSet}
        horizontalOrientation={orientationSettings[horizontalOrientation]}
      >
        <Content
          horizontalOrientation={orientationSettings[horizontalOrientation]}
        >
          {headline && <Header fontColor={fontColor}>{headline}</Header>}
          {subheadline && (
            <Subheader fontColor={fontColor}>{subheadline}</Subheader>
          )}
          {link && (
            <ButtonWrapper>
              <CtaButton
                href={link.target}
                variant={buttonVariant}
                onClick={() =>
                  reporter.tag(heroButtonClicked(link.text, link.target))
                }
              >
                {link.text}
              </CtaButton>
            </ButtonWrapper>
          )}
        </Content>
      </ContentContainer>
    </StyledHero>
  );
};

Hero.displayName = 'Hero';

Hero.propTypes = {
  headline: PropTypes.node,
  subheadline: PropTypes.string,
  link: PropTypes.shape({
    text: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
  }),
  backgroundColor: PropTypes.string,
  fontColor: PropTypes.string,
  image: PropTypes.object.isRequired,
  horizontalOrientation: PropTypes.oneOf(['left', 'center', 'right']),
  buttonVariant: PropTypes.string,
};
